import {Component} from '@angular/core';
import { Spinkit } from 'ng-http-loader';
import { BrandService } from '@services/brand.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent{
    public spinkit = Spinkit;

    filteredUrlPatterns : string[] = [
      'qr/firma',
      'qr/pix/estado',
      'qr/consultar',
      'coinag/transferencia',
      'destinatarios'
    ]

    public constructor(private brandService: BrandService) {
    }

    public get title(): string {
        return this.brandService.brandConfig.siteTitle;
    }
}
